import { useForm } from "react-hook-form";
import { useStore } from "../../../helpers";
import { defaultKeyContact } from "../key-contacts/key-contacts-schema";
import { useEffect } from "react";
import { toJS } from "mobx";

const useAddContacts = () => {
  const { projectWorkStoreV2 } = useStore();
  const { add_key_contacts } = projectWorkStoreV2;

  const onSubmit = (data) => {
    console.log(data);
  };

  const methods = useForm({
    defaultValues: defaultKeyContact,
  });

  const close_modal = () => {
    projectWorkStoreV2.update_project_work_property("add_key_contacts", false);
    projectWorkStoreV2.setSelectedContactToEdit(null);
  };
  useEffect(() => {
    if (!projectWorkStoreV2.selectedContactToEdit)
      methods.reset(defaultKeyContact);
    methods.reset(toJS(projectWorkStoreV2.selectedContactToEdit));
  }, [projectWorkStoreV2.selectedContactToEdit]);

  return {
    methods,
    add_key_contacts,
    onSubmit,
    close_modal,
    projectWorkStoreV2,
  };
};

export default useAddContacts;
